export const serializeObjectToUrlParams = (obj)=>{
    if(obj) {
        obj = Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
    }
    return new URLSearchParams(obj).toString();
}
